exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BackgroundPolygons-module__polygon1___TpeUj{left:-280px;top:-123px;background-image:url(/images/triangles/polygon1.svg)}.BackgroundPolygons-module__polygon1___TpeUj,.BackgroundPolygons-module__polygon2___1-vYI{position:absolute;background-position:50%;background-size:contain;background-repeat:no-repeat;z-index:-1;display:block;width:400px;height:400px}.BackgroundPolygons-module__polygon2___1-vYI{right:-207px;bottom:-241px;background-image:url(/images/triangles/polygon2.svg)}@media only screen and (max-width:900px){.BackgroundPolygons-module__polygon1___TpeUj{left:-175px;top:-62px;width:250px;height:250px}}@media only screen and (max-width:900px){.BackgroundPolygons-module__polygon2___1-vYI{right:-136px;bottom:-146px;width:250px;height:250px;background-image:url(/images/triangles/polygon2.1.svg)}}@media only screen and (max-width:340px){.BackgroundPolygons-module__polygon1___TpeUj,.BackgroundPolygons-module__polygon2___1-vYI{display:none}}", ""]);

// exports
exports.locals = {
	"polygon1": "BackgroundPolygons-module__polygon1___TpeUj",
	"polygon2": "BackgroundPolygons-module__polygon2___1-vYI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--6-1!./node_modules/sass-loader/lib/loader.js!./resources/assets/components/UI/BackgroundPolygons/BackgroundPolygons.module.scss
// module id = QqoL
// module chunks = 0